import { render, staticRenderFns } from "./SirenenView.vue?vue&type=template&id=5e463c0d&scoped=true"
import script from "./SirenenView.vue?vue&type=script&lang=js"
export * from "./SirenenView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e463c0d",
  null
  
)

export default component.exports